module.exports = __webpack_public_path__ + "media/images/logo/client-list_sp-664a662d561ff1a5695dcaf9b3231adb.svg";